module.exports = __webpack_public_path__ + "img/279.2bb55bf6.png";